<template>
    <article class="pf-radio">
        <div class="pf-radio__container">
            <div class="pf-radio__wrapper">
                <fieldset
                    v-for="(item, name, i) in this.radioData.values"
                    :key="i">
                    <input
                        class="visually-hidden"
                        type="radio"
                        :name="radioName"
                        :id="'radio-' + name"
                        :value="name"
                        v-model="value"
                        @change="chooseItem(name, i)"
                        :checked="activeRadioIndex === i ? true : false" />
                    <label
                        :for="'radio-' + name">
                        <span v-html="item"></span>
                    </label>
                </fieldset>
            </div>
        </div>
    </article>
</template>

<script>
    export default {
        name: 'Radio',
        data() {
            return {
                activeRadioIndex: 0,
                value: '',
            }
        },
        props: {
            radioData: {
                type: Array,
                default: []
            },
            radioName: {
                type: String,
                default: 'radio'
            },
            onloadValue: {
                type: String,
                default: ''
            }
        },
        methods: {
            chooseItem (item, index) {
                this.activeRadioIndex = index
                this.$emit('radioSelected', this.radioName, item)
            },
        },
        created() {
            if (this.onloadValue) {
                Object.keys(this.radioData.values).forEach((el, i) => {
                    if (el === this.onloadValue) {
                        this.activeRadioIndex = i
                    }
                })
            }
        }
    }
</script>